import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CreazionePraticaService } from '../../services/creazione-pratica.service';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { Scadenza } from 'src/app/common/models/scadenza';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-step-adempimenti',
  templateUrl: './step-adempimenti.component.html',
  styleUrls: ['./step-adempimenti.component.css']
})
export class StepAdempimentiComponent implements OnInit, OnDestroy {

  currentTab: string = TABS.LIST;
  tabs = TABS;
  scadenze: Scadenza[] = [];
  private componentDestroyed$: Subject<void> = new Subject<void>();

  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>();

  constructor(private creazionePraticaStoreService: CreazionePraticaStoreService) {
    this.creazionePraticaStoreService.scadenze$.pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.scadenze = response;
      if(this.scadenze == null) this.scadenze = [];
    });
  }

  ngOnInit() {
    /*else{
      this.currentTab = TABS.LIST;
    }*/
    //TSR-653 Lo step degli adempimenti nel wizard di creazione deve mostrare di default la lista degli adempimenti inseriti (eventualmente vuota) e non il form di inserimento.
  }

  ngOnDestroy(){
    this.componentDestroyed$.next();
  }

  setTab(type: string){
    this.currentTab = type;
  }

  onEmitAdempimentoSubmit(scadenza: Scadenza){
    this.scadenze.push(scadenza);
    console.log(this.scadenze);
    this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
    this.creazionePraticaStoreService.save();
    this.currentTab = TABS.LIST;
  }

  reset(): void{
    this.scadenze = [];
    this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
    this.creazionePraticaStoreService.save();
  }

  salva(): void{
    this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
    this.creazionePraticaStoreService.save();
    this.changeStep.emit();
  }

}

export enum TABS{
  LIST = 'list',
  CREATE = 'create'
}
